export default __webpack_public_path__ + "static/media/career-img-2.383387e7.png";